import { useCallback } from 'react';
import { Button } from '../components';
import type { ButtonProps } from '../components';
import type { DocumentId } from '../types';
import { useNavigateWithExpand } from '../hooks/useNavigateWithExpand';

type DocumentLinkProps = Omit<ButtonProps, 'to' | 'onClick'> & { documentId: DocumentId };

/**
 * This link uses navigation with expand and load document
 */
export function DocumentLink({ documentId: id, ...props }: DocumentLinkProps) {
  const navigate = useNavigateWithExpand();

  const onClick = useCallback<NonNullable<ButtonProps['onClick']>>(
    e => {
      e.stopPropagation();
      e.preventDefault();
      navigate(id);
    },
    [id],
  );

  return <Button onClick={onClick} {...props} />;
}
